import { render, staticRenderFns } from "./awardTable.vue?vue&type=template&id=d2c56386&scoped=true"
import script from "./awardTable.vue?vue&type=script&lang=js"
export * from "./awardTable.vue?vue&type=script&lang=js"
import style0 from "./awardTable.vue?vue&type=style&index=0&id=d2c56386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c56386",
  null
  
)

export default component.exports